import { Tooltip, TooltipContent, TooltipTrigger } from "@aircall/ds";
import { Phone } from "@aircall/react-icons";
import { useTranslation } from "react-i18next";

export function LabelCallType() {
  const { t } = useTranslation();

  return (
    <Tooltip>
      <TooltipTrigger
        render={
          <Phone
            className="size-4 text-muted-foreground"
            data-test="icon-call-type-title"
          />
        }
      />
      <TooltipContent>{t("call_type")}</TooltipContent>
    </Tooltip>
  );
}
